import { FollowButtonOutline, FollowButtonSize } from "@product/scmp-sdk";
import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { AuthorAvatar } from "~/components/author/author-avatar";
import { AuthorBio } from "~/components/author/author-bio";
import { AuthorHeaderBar } from "~/components/author/author-header-bar";
import type { defaultAuthorCardAuthor$key } from "~/queries/__generated__/defaultAuthorCardAuthor.graphql";

import {
  AuthorCardContainer,
  AvatarContainer,
  BioContainer,
  FollowButtonContainer,
  HeaderBarContainer,
  NameContainer,
  SocialLinksContainer,
  StyledAuthorName,
  StyledAuthorSocialLinks,
  StyledEntityFollowButton,
} from "./styles";

export type Props = {
  reference: defaultAuthorCardAuthor$key;
};

export const DefaultAuthorCard: FunctionComponent<Props> = ({ reference: reference_ }) => {
  const author = useFragment(
    graphql`
      fragment defaultAuthorCardAuthor on Author {
        ...authorSocialLinksAuthor
        ...authorAvatarAuthor
        ...authorNameAuthor
        ...authorBioAuthor
        ...entityFollowButtonBase
      }
    `,
    reference_,
  );

  return (
    <AuthorCardContainer>
      <AvatarContainer>
        <AuthorAvatar height={100} reference={author} width={100} placeholder />
      </AvatarContainer>
      <HeaderBarContainer>
        <AuthorHeaderBar />
      </HeaderBarContainer>
      <FollowButtonContainer>
        <StyledEntityFollowButton
          outline={FollowButtonOutline.Outlined}
          reference={author}
          size={FollowButtonSize.Thin}
          source="Article_bottom"
        />
      </FollowButtonContainer>
      <NameContainer>
        <StyledAuthorName reference={author} />
      </NameContainer>
      <BioContainer>
        <AuthorBio reference={author} />
      </BioContainer>
      <SocialLinksContainer>
        <StyledAuthorSocialLinks reference={author} />
      </SocialLinksContainer>
    </AuthorCardContainer>
  );
};

DefaultAuthorCard.displayName = "DefaultAuthorCard";
